import { RefObject, useEffect } from 'react';

const useAutosizeTextArea = (
  textAreaRef: RefObject<HTMLTextAreaElement> | null,
  value: string
): void => {
  const maxHeight = 160;

  useEffect(() => {
    if (textAreaRef?.current) {
      textAreaRef.current.style.height = '40px';

      const { scrollHeight } = textAreaRef.current;

      textAreaRef.current.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
    }
  }, [textAreaRef, value]);
};

export default useAutosizeTextArea;
